/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import './Porcoes.css'
import CardPratos from './../CardPratos/CardPratos';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import { fireBaseApp } from './../../App';

const Porcoes = () => {
  const [pratos, setPratos] = useState([]);

  const db = getFirestore(fireBaseApp);
  const cardapioRef = collection(db, 'Porcoes');

  const getPratos = async () => {
    const data = await getDocs(cardapioRef);
    const porcoes = data.docs.map(doc => doc.data());
    setPratos(porcoes);
  };

  useEffect(() => {
    getPratos();
  }, []);

  return (
    <section id="porcoes">
      <h2>PORÇÕES EXTRAS</h2>
      <ul>
        {pratos.map((prato, index) => (
          <CardPratos prato={prato} key={`@porcoes-${index}`}/>
        ))}
      </ul>
    </section>
  )
}

export default Porcoes